<template>
    <div class="form-group">
        <label>{{ name }}</label>
        <select class="form-control" :name="'filter_'+id" :title="name" v-model="value_inner">
            <option value="">{{ t_none }}</option>
            <option value="1">{{ t_yes }}</option>
            <option value="0">{{ t_no }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value'],
        data: function() {
            return {
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                t_none: Lang.langGet("-- ignore --"),
                value_inner: this.value
            }
        },
        watch: {
            value_inner: function(val,oldVal){
                EaseEventBus.fire('resetExistingFilters');
                this.$emit('input',val);
            }
        }
    }
</script>
